/**
 * Helpers to keep list page/search/filter when opening a detail and navigating back.
 */

export const persistListReturn = (fromKey, stateKey, from, listState) => {
  if (from) {
    sessionStorage.setItem(fromKey, from);
  }
  if (listState) {
    sessionStorage.setItem(stateKey, JSON.stringify(listState));
  } else {
    sessionStorage.removeItem(stateKey);
  }
};

export const consumeListReturn = (fromKey, stateKey, locationState = {}) => {
  const from =
    locationState?.from ||
    sessionStorage.getItem(fromKey) ||
    null;

  let listState = locationState?.listState;
  if (!listState) {
    const stored = sessionStorage.getItem(stateKey);
    if (stored) {
      try {
        listState = JSON.parse(stored);
      } catch {
        listState = undefined;
      }
    }
  }

  sessionStorage.removeItem(fromKey);
  sessionStorage.removeItem(stateKey);

  return { from, listState };
};

export const applyListState = (listState, setters = {}) => {
  if (!listState) return;

  if (listState.page != null && setters.setPage) {
    setters.setPage(Number(listState.page) || 1);
  }
  if (listState.search !== undefined && setters.setSearch) {
    setters.setSearch(listState.search);
  }
  if (listState.filter !== undefined && setters.setFilter) {
    setters.setFilter(listState.filter);
  }
  if (listState.searchTerm !== undefined && setters.setSearchTerm) {
    setters.setSearchTerm(listState.searchTerm);
  }
  if (listState.currentPage != null && setters.setCurrentPage) {
    setters.setCurrentPage(Number(listState.currentPage) || 1);
  }
  if (listState.tabType !== undefined && setters.setTabType) {
    setters.setTabType(listState.tabType);
  }
};

export const LIST_RETURN_KEYS = {
  ORDER: {
    from: "orderViewReturnTo",
    state: "orderViewReturnListState",
  },
  CUSTOMER: {
    from: "customerViewReturnTo",
    state: "customerViewReturnListState",
  },
  RESTAURANT: {
    from: "restaurantViewReturnTo",
    state: "restaurantViewReturnListState",
  },
  DISH_APPROVAL: {
    from: "dishApprovalViewReturnTo",
    state: "dishApprovalViewReturnListState",
  },
  TRANSACTION: {
    from: "transactionViewReturnTo",
    state: "transactionViewReturnListState",
  },
};
